import { render } from "./TopNavbar.vue?vue&type=template&id=f5f383ba&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"

import "./TopNavbar.vue?vue&type=style&index=0&id=f5f383ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f383ba"]])

export default __exports__